<template>
  <div class="page-container">
    <van-nav-bar fixed left-arrow title="我的竞买" z-index="10" @click-left="goableBack()">
      <template #right>
        <van-button plain type="primary"
          style="background-color: transparent;border: none;color: blue;border-bottom: 1px solid blue;border-radius: 0;"
          @click="getForward('user')">合同-明细</van-button>
      </template>
    </van-nav-bar>
    <van-sticky offset-top="46">
      <div class="amount-box">
        <div class="d1">
          <div class="sp1">成交金额(元)</div>
          <div class="sp2">{{ numFormat(pydData.cost || 0) }}</div>
        </div>
        <div class="d2">
          <div class="sp1">待收金额(元)</div>
          <div class="sp2">{{ numFormat(pydData.pydWillAmount || 0) }}</div>
        </div>
        <div class="d3">
          <div class="sp1">可用余额(元)</div>
          <div class="sp2">{{ numFormat(pydData.pydBalance || 0) }}</div>
        </div>
      </div>
      <div class="chongzhi">
        <van-button class="b1" plain @click="getForward('payout')">提现</van-button>
        <van-button class="b2" plain @click="getForward('money')">充值</van-button>
        <van-button class="b3" plain @click="getForward('bank')">换/绑卡</van-button>
      </div>
    </van-sticky>
    <van-tabs class="tabs-bg" v-model="tabActive" swipeable sticky line-height="3" title-active-color="rgb(0, 0, 0)"
      title-inactive-color="rgb(133, 133, 133)" offset-top="187">
      <van-tab v-for="(item, index) in tabsList" :title="item.title" :key="index">
        <div class="container">
          <AuctionList :tabObject="item" :active="tabActive"> </AuctionList>
        </div>
      </van-tab>
    </van-tabs>


  </div>
</template>

<script>
import { Tab, Tabs, Button, Sticky } from "vant"
import { mapGetters, mapMutations } from "vuex"
import * as ProductApi from "@/api/product"
import AuctionList from "./auctionList1.vue"
import session from "../../utils/session.js"
export default {
  name: "myauction1",
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Sticky.name]: Sticky,
    [Button.name]: Button,
    AuctionList
  },
  data() {
    return {
      tabActive: 0,
      tabsList: [
        { title: "已竞买", type: "2" },
        { title: "已结清", type: "3" }
      ],
      pydData: {
        cost: 0,
        pydWillAmount: 0,
        pydBalance: 0,
      }
    }
  },
  beforeMount() { },
  watch: {},
  computed: {
    ...mapGetters(["channel", "os", "token", "userInfo"]),
  },
  mounted() {
    if (session.get("myauction-tab")) {
      this.tabActive = Number(session.get("myauction-tab"))
      session.del("myauction-tab")
    }
    ProductApi.queryPydData({ custId: this.userInfo.custAccount.custId })
      .then((data) => {
        if (data) {
          this.pydData = data
        }
      })
      .catch((e) => {
        Toast(e.msg || e.message)
      })
  },
  methods: {
    getForward(target) {
      ProductApi.getForward({ custId: this.userInfo.custAccount.custId, target: target })
        .then((data) => {
          if (data) {
            location.href = data
            return
            this.$router.push({ name: "webview-page", query: { title: target === 'payout' ? '提现' : target === 'money' ? '充值' : target === 'user' ? '用户中心' : '换/绑卡', url: encodeURIComponent(data) } })
          }
        })
        .catch((e) => {
          Toast(e.msg || e.message)
        })
    },
  }
}
</script>

<style lang="less" scoped>
// 下划线设置
// ::v-deep .van-tabs__line {
//   position: absolute;
//   bottom: 20px;
//   left: 0;
//   z-index: 1;
//   height: 3px;
//   width: 30px !important;
//   background-color: #fc6524;
//   border-radius: 0.08rem;
// }
// 文本选择和默认颜色设置
// ::v-deep .van-tab {
//   color: #999;
// }
// ::v-deep .van-tab--active {
//   color: #333333;
// }
// 文本字体设置
::v-deep .van-tab__text {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  // background: rgba(255, 255, 255, 0.6);
}

::v-deep .van-hairline--top-bottom:after {
  border: none;
}

.amount-box {
  padding: 10px 15px;
  font-size: 14px;
  color: rgb(51, 51, 51);
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eee;

  .d1,
  .d2,
  .d3 {
    text-align: center;

    .sp1 {
      color: rgb(102, 102, 102);
    }

    .sp2 {
      color: rgb(51, 51, 51);
      font-weight: 700;
    }
  }
}

.chongzhi {
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  padding: 15px;
  border-bottom: 1px solid rgb(238, 238, 238);

  .b1 {
    width: 30%;
    height: 33px;
    color: rgb(102, 102, 102);
    border: none;
    background-color: rgb(242, 242, 242);
  }

  .b2 {
    width: 30%;
    height: 33px;
    margin-left: 15px;
    color: #fff;
    border: none;
    background-color: rgb(252, 101, 36);
  }

  .b3 {
    width: 30%;
    height: 33px;
    margin-left: 15px;
    color: #fff;
    border: none;
    background-color: rgb(252, 43, 36);
  }
}
</style>>
